var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticClass:"title"},[_vm._v("GBF 羅盤儀")]),_c('SearchBox',{attrs:{"msg":"start the first box"}}),_c('back-to-top',{attrs:{"text":"","visibleoffset":"400"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }